import { Fragment, Suspense } from 'react';
import AddToCartButton from '@/components/blocks/add_to_cart_button/AddToCartButton';
import AllReviews from '@/components/blocks/all_reviews/AllReviews';
import AutoSlider from '@/components/blocks/auto_slider/AutoSlider';
import BannerContent from '@/components/blocks/banner/BannerContent';
import BundleOfferData from './blocks/bundleOffer/BundleOfferData';
import Calendly from '@/components/blocks/calendly/Calendly';
import CardsSlider from '@/components/blocks/cards_slider/CardsSlider';
import CartCrossSellFullParent from '@/components/blocks/editorial/parent';
import CartSummary from './commerce/cart/CartSummary';
import Cleanhub from '@/components/blocks/cleanhub_widget/Cleanhub';
import CollectionsShowcase from '@/components/blocks/collections_showcase/CollectionsShowcase';
import CompanyUSP from './blocks/company_usp/CompanyUSP';
import CompareMattresses from '@/components/blocks/compare_mattresses/CompareMattresses';
import ContactCx from '@/components/blocks/cart/contactCx/contactCx';
import ContentListContent from '@/lib/api/content_list/ContentListContent';
import CrossSell from '@/components/blocks/cross_sell/CrossSell';
import CustomerReviews from '@/components/blocks/customer_reviews/CustomerReviews';
import CxHelp from '@/components/blocks/cx_help/CxHelp';
import DetailFeature from '@/components/blocks/detail_feature/DetailFeature';
import DonationBannerContent from '@/lib/api/donation_banner/DonationBannerData';
import EcomWayfinderContent from '@/lib/api/ecom_wayfinder.js/ecomWayfinder';
import Editorial from '@/components/blocks/editorial/Editorial';
import EmailSubscribe from '@/components/blocks/email_subscribe/EmailSubscribe';
import ExpertReviews from '@/components/blocks/expert_reviews/ExpertReviews';
import FaqSection from '@/components/blocks/faq/Faq';
import FeatureMediaText from '@/components/blocks/feature_media_text/FeatureMediaText';
import FeaturedArticles from '@/components/blocks/articles_slider/FeaturedArticleSlider';
import FinanceHero from '@/components/blocks/finance_hero/FinanceHero';
import FullWidthFeature from '@/components/blocks/full_width_feature/FullWidthFeature';
import HeaderSticky from '@/components/blocks/header_sticky/HeaderSticky';
import HeroBoxLinks from '@/components/blocks/hero_box_links/HeroBoxLinks';
import HeroContent from '@/lib/api/hero_content/HeroContentData';
import HeroLargeBackgroundImage from './blocks/hero_large_background_image/HeroLargeBackgroundImage';
import HeroWithBackgroundImage from '@/components/blocks/hero_with_background_image/HeroWithBackgroundImage';
import HighlightContent from '@/lib/api/highlight/HighlightContent';
import HTMLSitemap from '@/components/blocks/html_sitemap/HtmlSitemap';
import IframeEmbed from '@/components/blocks/iframe_embed/IframeEmbed';
import InfoBanner from '@/components/blocks/info_banner/InfoBanner';
import LabData from '@/components/blocks/lab_data/LabData';
import LayersAccordionData from '@/lib/api/layers_accordion/LayersAccordionData';
import LayersAccordionOneImage from './blocks/layers_accordion_one_image/LayersAccordionOneImage';
import MicrositeAddToCart from '@/components/blocks/microsite_add_to_cart/MicrositeAddToCart';
import MicrositeHeroLargeBackgroundImage from './blocks/hero_large_background_image/MicrositeHeroLargeBackgroundImage';
import MicrositePdpPrice from './blocks/microsite_pdp_price/MicrositePDPprice';
import MicrositeProductTitle from './blocks/microsite_product_title/MicrositeProductTitle';
import MicrositeSticky from '@/components/blocks/microsite_sticky/MicrositeSticky';
import MicrositeUSP from './blocks/micrositeUSP/MicrositeUSP';
import Notification from '@/components/blocks/notification/Notification';
import OptOutForm from '@/components/blocks/opt_out_form/OptOutForm';
import PDPCompanyUSP from './blocks/company_usp/PDPCompanyUSP';
import PdpPrice from '@/components/blocks/pdp_price/PdpPrice';
import PpdWidget from './blocks/pdp_widget/PpdWidget';
import ProductCarousel from '@/components/blocks/product_carousel/ProductCarousel';
import ProductGroup from './blocks/product_group/ProductGroup';
import ProductTabs from '@/components/blocks/product_tabs/ProductTabs';
import ProductTitle from '@/components/blocks/product_title/ProductTitle';
import PropsBanner from '@/components/blocks/props_banner/PropsBanner';
import RatingsReviews from '@/components/blocks/ratings_and_reviews/RatingsReview';
import RichTextEditor from '@/components/blocks/rich_text_editor/RichTextEditor';
import SidebarBottomLink from '@/components/blocks/sidebar_bottom_link/SidebarBottomLink';
import SocialProof from '@/components/blocks/social_proof/SocialProof';
import StoreLocator from './store/store_locator';
import TabbedCardList from '@/components/blocks/tabbed_card_list/TabbedCardList';
import TimelineSlider from '@/components/blocks/timeline_slider/TimelineSlider';
import TitleAndText from './blocks/title_and_text/TitleAndText';
import TitleSection from './title/title_section/TitleSection';
import TypeformWidget from './blocks/typeform_widget/TypeformWidget';
import UGCGallery from './blocks/ucg_gallery/UGCGallery';
import UpsellToggle from './blocks/upsell_toggle/UpsellToggle';
import VariantSelector from './blocks/variant_selector/VariantSelector';
import VideoCarousel from './blocks/video_carousel/VideoCarousel';
import VideoLargeAutoplay from '@/components/blocks/video_large_autoplay/VideoLargeAutoplay';
import Wayfinder from '@/components/blocks/wayfinder/Wayfinder';
import ZipcodeChecker from './blocks/zipcode_checker/ZipcodeChecker';
import WallOfReviews from './blocks/wall_of_reviews/WallOfReviews';

// Wrapped in <Suspense> by default. Exceptions live in shellEnabledMap below.
const componentMap = {
  header_sticky: HeaderSticky,
  articles_slider: FeaturedArticles,
  auto_slider: AutoSlider,
  cards_slider: CardsSlider,
  cart_summary: CartSummary,
  content_list: ContentListContent,
  customer_reviews: CustomerReviews,
  ecom_wayfinder: EcomWayfinderContent,
  microsite_sticky: MicrositeSticky,
  microsite_add_to_cart: MicrositeAddToCart,
  microsite_pdp_price: MicrositePdpPrice,
  ratings_and_reviews: RatingsReviews,
  social_proof: SocialProof,
  tabbed_card_list: TabbedCardList,
  timeline_slider: TimelineSlider,
  product_carousel: ProductCarousel,
  wayfinder: Wayfinder,
  wall_of_reviews: WallOfReviews,

  // Product detail blocks
  bundle_offer: BundleOfferData,
  cross_sell: CrossSell
};

/**
 * Blocks that are either fully static or manage their own <Suspense> boundaries.
 *
 * Move blocks here if they don't need to be wrapped by <Suspense> in SliceZone.
 * Wrapping blocks like these in <Suspense> will throw out all the work they do
 * to manage their own loading states, and the entire block will have to stream in.
 *
 * It's much better to write blocks with static shells, so prefer adding to this
 * list so it can one day eclipse the componentMap entirely.
 */
const shellEnabledMap = {
  all_reviews: AllReviews,
  banner: BannerContent,
  cart_cross_sell_full: CartCrossSellFullParent,
  calendly: Calendly,
  cleanhub_widget: Cleanhub,
  collections_showcase: CollectionsShowcase,
  company_usp: CompanyUSP,
  compare_mattresses: CompareMattresses,
  contact_cx: ContactCx,
  cx_help: CxHelp,
  detail_feature: DetailFeature,
  donation_banner: DonationBannerContent,
  editorial: Editorial,
  email_subscribe: EmailSubscribe,
  expert_reviews: ExpertReviews,
  faq: FaqSection,
  feature_media_text: FeatureMediaText,
  finance_hero: FinanceHero,
  full_width_feature: FullWidthFeature,
  hero_box_links: HeroBoxLinks,
  hero_content: HeroContent,
  hero_large_background_image: HeroLargeBackgroundImage,
  hero_with_background_image: HeroWithBackgroundImage,
  highlight: HighlightContent,
  html_sitemap: HTMLSitemap,
  iframe_embed: IframeEmbed,
  info_banner: InfoBanner,
  lab_data: LabData,
  layers_accordion: LayersAccordionData,
  layers_accordion_one_image: LayersAccordionOneImage,
  microsite_hero_with_large_background_image: MicrositeHeroLargeBackgroundImage,
  microsite_product_title: MicrositeProductTitle,
  microsite_usp: MicrositeUSP,
  notification: Notification,
  opt_out_form: OptOutForm,
  pdp_widget: PpdWidget,
  product_group: ProductGroup,
  props_banner: PropsBanner,
  rich_text_editor: RichTextEditor,
  sidebar_bottom_link: SidebarBottomLink,
  store_locator: StoreLocator,
  title_and_text: TitleAndText,
  title_section: TitleSection,
  typeform_widget: TypeformWidget,
  ugc_gallery: UGCGallery,
  video_carousel: VideoCarousel,
  video_large_autoplay: VideoLargeAutoplay,
  zipcode_checker: ZipcodeChecker,

  // Product detail blocks
  add_to_cart_button: AddToCartButton,
  pdp_company_usp: PDPCompanyUSP,
  pdp_price: PdpPrice,
  product_description: ProductTabs,
  product_title: ProductTitle,
  upsell_toggle: UpsellToggle,
  variant_selector: VariantSelector
};

const SliceZone = ({ blocks, template }) => {
  return (
    <>
      {blocks.map((block, index) => {
        const blockType = Object.keys(block)[0];
        const hasStaticShell = Object.hasOwn(shellEnabledMap, blockType);
        const Component = shellEnabledMap[blockType] ?? componentMap[blockType];

        if (!Component) {
          return <div key={index} className="empty-component"></div>;
        }

        const rendered = (
          <Component block={block} position={index} template={template} />
        );

        return hasStaticShell ? (
          <Fragment key={index}>{rendered}</Fragment>
        ) : (
          <Suspense key={index}>{rendered}</Suspense>
        );
      })}
    </>
  );
};

export default SliceZone;
